export const GET_SPV_LIGHT_NODES = 'GET_SPV_LIGHT_NODES'
